import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const siteUrl = 'https://g-2technologies.com';

const pageMeta = {
    '/': {
        title: 'G2 Technologies | Website & Custom Application Builders in Menominee, MI',
        description: 'G2 Technologies builds custom websites, business applications, API integrations, and software solutions for businesses in Menominee, MI and beyond.',
    },
    '/websolutions': {
        title: 'Custom Website & Application Development in Menominee, MI | G2 Technologies',
        description: 'Need website builders or custom application builders near Menominee, MI? G2 Technologies designs and builds scalable websites, apps, and business software.',
    },
    '/aisolutions': {
        title: 'AI Solutions for Business | G2 Technologies',
        description: 'G2 Technologies helps businesses use artificial intelligence to improve operations, automate workflows, and build smarter digital products.',
    },
    '/apisolutions': {
        title: 'API Integration Services | G2 Technologies',
        description: 'Connect systems, automate data flow, and improve software workflows with custom API integration services from G2 Technologies.',
    },
    '/service': {
        title: 'Software Development Services in Menominee, MI | G2 Technologies',
        description: 'Explore website development, custom software, application support, API integrations, and technology consulting from G2 Technologies.',
    },
    '/about': {
        title: 'About G2 Technologies | Menominee Software & Website Builders',
        description: 'Learn about G2 Technologies, a software and website development company serving Menominee, MI and businesses across the U.S.',
    },
    '/contact': {
        title: 'Contact G2 Technologies | Website & Software Builders in Menominee, MI',
        description: 'Contact G2 Technologies to discuss a custom website, software application, API integration, or digital solution for your business.',
    },
    '/pricing': {
        title: 'Website & Application Development Pricing | G2 Technologies',
        description: 'Review pricing options for custom website, software application, and digital solution projects from G2 Technologies.',
    },
    '/blog': {
        title: 'Software & Web Development Blog | G2 Technologies',
        description: 'Read insights from G2 Technologies on web development, custom applications, software strategy, and modern business technology.',
    },
};

const setMetaTag = (name, content, attribute = 'name') => {
    let tag = document.querySelector(`meta[${attribute}="${name}"]`);

    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attribute, name);
        document.head.appendChild(tag);
    }

    tag.setAttribute('content', content);
};

const setCanonical = (href) => {
    let link = document.querySelector('link[rel="canonical"]');

    if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
    }

    link.setAttribute('href', href);
};

const SEO = () => {
    const location = useLocation();

    useEffect(() => {
        const meta = pageMeta[location.pathname] || pageMeta['/'];
        const canonical = `${siteUrl}${location.pathname === '/' ? '' : location.pathname}`;

        document.title = meta.title;
        setMetaTag('description', meta.description);
        setMetaTag('og:title', meta.title, 'property');
        setMetaTag('og:description', meta.description, 'property');
        setMetaTag('og:url', canonical, 'property');
        setMetaTag('twitter:title', meta.title);
        setMetaTag('twitter:description', meta.description);
        setCanonical(canonical);
    }, [location.pathname]);

    return null;
};

export default SEO;
